import { ReactNode } from 'react';
import { Box } from '@mui/material';

export interface IMplTabPanelProps {
	children: ReactNode;
	value: string | number;
	activeValue: string | number;
	dataTestId?: string;
}

export const MplTabPanel = ({
	children,
	value,
	activeValue,
	dataTestId,
}: IMplTabPanelProps) => {
	return (
		<Box
			role="tabpanel"
			hidden={value !== activeValue}
			data-testid={dataTestId}
			sx={{
				display: value === activeValue ? 'block' : 'none',
			}}
		>
			{value === activeValue && children}
		</Box>
	);
};
